import React, { useState, useEffect } from "react";
import styles from "./modalWrapper.scss";

const ModalWrapper = (props) => {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    setWidth(window.innerWidth);
  });
  const getWrapperPosition = () => {
    const searchLeft =
      width - props.desktopSearchRef?.current?.getBoundingClientRect()?.right;
    return searchLeft;
  };
  return (
    <div
      className={styles["modal-wrapper"]}
      style={{ right: getWrapperPosition() }}
    >
      {props.children}
    </div>
  );
};

export { ModalWrapper };
